import $ from 'jquery'

export default () => {
    const showSettingsButton = $('.js-show-cookie-settings > a');

    showSettingsButton.on('click', function(e) {
        e.preventDefault();
        if (typeof window.OneTrust !== `undefined`) {
            window.OneTrust.ToggleInfoDisplay();
        }
    })
}
